export default {
    data() {
        return {
            HOME_TITLE: this.$global.HOME_TITLE
        }
    },
    computed: {
        routerTabs() {
            return this.$store.state.pageTabs;
        }
    },
    mounted: function() {

    },
    methods: {
        toRouter: function(url) {
            this.$router.push(url);
        },
        removeRouter: function(index) {
            var routerTabs = this.$store.state.pageTabs;
            routerTabs.splice(index, 1);
            var checkedCount = 0;
            routerTabs.forEach(elem => {
                checkedCount += elem.checked ? 1 : 0;
            });
            if (checkedCount == 0) {
                routerTabs[routerTabs.length - 1].checked = true;
                this.$router.push(routerTabs[routerTabs.length - 1].url);
            }
            this.$store.state.pageTabs = routerTabs;
        }
    }
}